// @flow
export default function createReducer(initialState: any, handlers: { [key: string]: Function }) {
  return function reducer(state: any = initialState, action: { type: string }) {
    if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}
